import { BookIcon, MarkGithubIcon } from '@primer/octicons-react';
import { DiscordGlyph } from './icons/DiscordGlyph';
import styles from './header.module.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var GITHUB_URL = 'https://github.com/LambdaTest/kane-cli';
var DISCORD_URL = 'https://discord.gg/SqVMtNeWEf';
var DOCS_URL = 'https://www.testmuai.com/docs/kane-cli-introduction';

/**
 * The right-hand utility links shared by every header surface — GitHub,
 * Discord and Docs as icon-only links. All open in a new tab and carry an
 * accessible label + tooltip.
 */
export function HeaderLinks() {
  return /*#__PURE__*/_jsxs("nav", {
    className: styles.links,
    "aria-label": "Evidence Viewer resources",
    children: [/*#__PURE__*/_jsx("a", {
      className: styles.iconLink,
      href: GITHUB_URL,
      target: "_blank",
      rel: "noopener noreferrer",
      "aria-label": "GitHub",
      title: "GitHub",
      children: /*#__PURE__*/_jsx(MarkGithubIcon, {
        size: 18
      })
    }), /*#__PURE__*/_jsx("a", {
      className: styles.iconLink,
      href: DISCORD_URL,
      target: "_blank",
      rel: "noopener noreferrer",
      "aria-label": "Discord",
      title: "Discord",
      children: /*#__PURE__*/_jsx(DiscordGlyph, {
        size: 18
      })
    }), /*#__PURE__*/_jsx("a", {
      className: styles.iconLink,
      href: DOCS_URL,
      target: "_blank",
      rel: "noopener noreferrer",
      "aria-label": "Docs",
      title: "Docs",
      children: /*#__PURE__*/_jsx(BookIcon, {
        size: 18
      })
    })]
  });
}